import React from "react";
import { Box, Typography } from "@mui/material";

const UpdatesTable = ({ updates }) => {
  return (
    <Box>
      {updates.map((u, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            alignItems: "center",
            py: 1,
            borderBottom:
              idx !== updates.length - 1
                ? "1px solid rgba(0,0,0,0.08)"
                : "none",
          }}
        >
          {/* Left content */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2">
              <strong>{u.student}</strong> {u.action}
            </Typography>
          </Box>

          {/* Time */}
          <Box sx={{ minWidth: 70, textAlign: "right" }}>
            <Typography variant="caption" color="text.secondary">
              {u.time}
            </Typography>
          </Box>

          {/* Score (fixed width) */}
          <Box sx={{ width: 40, textAlign: "right", ml: 2 }}>
            <Typography variant="caption">
              {u.score}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default UpdatesTable;
